/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* ORFEVA — 2026-08 : mention de stock de la fiche produit.
   - quantité > 0 et produit « Chaîne » : « En stock » (vert)
   - quantité > 0 et <= seuil : « Seulement X disponible(s) - Expédié(e) sous 24h ouvrées » (vert)
   - quantité > 0 et > seuil : « En stock - Expédié(e) sous 24h ouvrées » (vert)
   - quantité <= 0 et métafield variante magento.pastille_livraison renseigné :
     « Sur commande - Livré(e) sous {délai} »
   - quantité <= 0 sans délai renseigné : « Sur commande - Nous contacter »
   - sinon : mention masquée.
   Le rendu initial est fait en Liquid (sections/main-product.liquid) ; ce script
   gère les changements de variante (événement venue:variant:updated du thème)
   et relit les attributs data-qty / data-delai de l'option sélectionnée. */
(function () {
  function selectedOption(note) {
    var root = note.closest('[data-section-type="product-single"]') || note.closest('form') || document;
    var select = root.querySelector('.js-product-variant-select');
    if (select && select.options && select.selectedIndex >= 0) return select.options[select.selectedIndex];
    return null;
  }
  function render(note) {
    var opt = selectedOption(note);
    if (!opt) return;
    if (opt.getAttribute('data-tracked') === 'false') { note.style.display = 'none'; return; } // stock non suivi
    var qtyAttr = opt.getAttribute('data-qty');
    if (qtyAttr === null || qtyAttr === '') return;
    var qty = parseInt(qtyAttr, 10);
    if (isNaN(qty)) return;
    var limit = parseInt(note.getAttribute('data-qty-limit'), 10);
    var delai = (opt.getAttribute('data-delai') || '').trim().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    var tplStock = note.getAttribute('data-tpl-stock') || '';
    var tplInStock = note.getAttribute('data-tpl-instock') || '';
    var tplChain = note.getAttribute('data-tpl-chain') || '';
    var isChain = note.getAttribute('data-is-chain') === 'true';
    var tplOrder = note.getAttribute('data-tpl-order') || '';
    var tplContact = note.getAttribute('data-tpl-contact') || '';
    note.classList.toggle('is-in-stock', qty > 0);
    if (qty > 0) {
      if (isChain && tplChain) {
        note.innerHTML = tplChain;
        note.style.display = '';
      } else if (!isNaN(limit) && qty <= limit && tplStock) {
        note.innerHTML = tplStock.replace('__QTY__', String(qty));
        note.style.display = '';
      } else if (tplInStock) {
        note.innerHTML = tplInStock;
        note.style.display = '';
      } else {
        note.style.display = 'none';
      }
    } else if (delai && tplOrder) {
      note.innerHTML = tplOrder.replace('__DELAI__', delai);
      note.style.display = '';
    } else if (tplContact) {
      note.innerHTML = tplContact;
      note.style.display = '';
    } else {
      note.style.display = 'none';
    }
  }
  function renderAll() {
    var notes = document.querySelectorAll('.js-price-stock-note');
    for (var i = 0; i < notes.length; i++) render(notes[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAll);
  } else {
    renderAll();
  }
  document.addEventListener('venue:variant:updated', function () { setTimeout(renderAll, 0); });
})();
